import React, { useState } from 'react';
import Loader from '../../../../shared/react/components/loader.jsx';
import { useTranslationContext } from "./project-builder-main.jsx";

export default function DownloadsButtons({ guid, projectName, projectId, isMarketingProject }) {
    const {translations} = useTranslationContext();

    const [quoteIsLoading, setQuoteIsLoading] = useState(false);
    const [condensedQuoteIsLoading, setCondensedQuoteIsLoading] = useState(false);
    const [sheetIsLoading, setSheetIsLoading] = useState(false);
    const [csvIsLoading, setCsvIsLoading] = useState(false);
    const [excelIsLoading, setExcelIsLoading] = useState(false);

    const apiHeader = () => {
        let authToken = JSON.parse(sessionStorage.getItem('authToken'));
        let header = {
            'Authorization': 'Bearer ' + authToken.Token
        }
        return header;
    }

    const url = window.location.href;

    const handleDownloadCsv = () => {
        setCsvIsLoading(true);

        let csvUrl = url.split("/")[0] + "//" + url.split("/")[2] + "/api/projectBuilder/projects/" + projectId + "/csv";

        fetch(csvUrl, {
            headers: apiHeader()
        }).then(x => x.blob())
            .then(x => {
                let a = document.createElement('a');
                a.href = URL.createObjectURL(x);
                a.setAttribute('target', '_blank');
                a.setAttribute('download', 'ProjectBuider_' + projectId + "_" + projectName);
                a.click();
                a.remove();
                setCsvIsLoading(false);
            });
    }

    const handleDownloadExcel = () => {
        setExcelIsLoading(true);

        let excelUrl = url.split("/")[0] + "//" + url.split("/")[2] + "/api/projectBuilder/projects/" + projectId + "/excel";

        fetch(excelUrl, {
            headers: apiHeader()
        }).then(x => x.blob())
            .then(x => {
                let a = document.createElement('a');
                a.href = URL.createObjectURL(x);
                a.setAttribute('target', '_blank');
                a.setAttribute('download', 'ProjectBuider_' + projectId + "_" + projectName);
                a.click();
                a.remove();
                setExcelIsLoading(false);
            });
    }

    const handleDownloadQuote = () => {
        setQuoteIsLoading(true);

        let pdfUrl = url.split("/")[0] + "//" + url.split("/")[2] + "/api/projectBuilder/projects/" + projectId + "/Pdf";

        fetch(pdfUrl, {
            headers: apiHeader()
        }).then(x => x.blob())
            .then(x => {
                let a = document.createElement('a');
                a.href = URL.createObjectURL(x);
                a.setAttribute('target', '_blank');
                a.setAttribute('download', projectName + ' Project Quote');
                a.click();
                a.remove();
                setQuoteIsLoading(false);
            });
    }

    const handleDownloadCondensedQuote = () => {
        setCondensedQuoteIsLoading(true);

        let pdfUrl = url.split("/")[0] + "//" + url.split("/")[2] + "/api/projectBuilder/projects/" + projectId + "/condensedpdf?ispujadas=1";

        fetch(pdfUrl, {
            headers: apiHeader()
        }).then(x => x.blob())
            .then(x => {
                let a = document.createElement('a');
                a.href = URL.createObjectURL(x);
                a.setAttribute('target', '_blank');
                a.setAttribute('download', `ProjectBuilder_${projectId}_${projectName}`);
                a.click();
                a.remove();
                setCondensedQuoteIsLoading(false);
            });
    }

    const handleDownloadSellSheet = () => {
        setSheetIsLoading(true);

        let sheetUrl = url.split("/")[0] + "//" + url.split("/")[2] + "/api/projectBuilder/projects/" + projectId + "/specSheetPdf";

        fetch(sheetUrl, {
            headers: apiHeader()
        }).then(x => x.blob())
            .then(x => {
                let a = document.createElement('a');
                a.href = URL.createObjectURL(x);
                a.setAttribute('target', '_blank');
                a.setAttribute('download', projectName + ' Sell Sheets');
                a.click();
                a.remove();
                setSheetIsLoading(false);
            });

    }
    

    return (
        <div className="quote-downloads">
        {isMarketingProject
            ? sheetIsLoading
                ? <Loader show={true} />
                : <button type="button" className="link-btn" onClick={handleDownloadSellSheet}><span className="icon icon--download"></span>{translation.DownloadSellSheets}</button>
        : <>
            {condensedQuoteIsLoading
                ? <Loader show={true} />
                : <button type="button" className="link-btn" onClick={handleDownloadCondensedQuote}><span className="icon icon--download"></span>{translations.DownloadPdfQuote}</button>
            }

            {csvIsLoading
                ? <Loader show={true} />
                : <button type="button" className="link-btn" onClick={handleDownloadCsv}><span className="icon icon--download"></span>{translations.DownloadCsvQuote}</button>
            }

            {excelIsLoading
                ? <Loader show={true} />
                : <button type="button" className="link-btn" onClick={handleDownloadExcel}><span className="icon icon--download"></span>{translations.DownloadExcelQuote}</button>
            }

            {sheetIsLoading
                ? <Loader show={true} />
                : <button type="button" className="link-btn" onClick={handleDownloadSellSheet}><span className="icon icon--download"></span>{translations.DownloadSellSheets}</button>
            }
        </>
        }
        </div>
    );
}